import type { AddressBookEntry } from './addressBookTypes'

export const formatAddressForProfile = (entry: AddressBookEntry, countryLabel: string) => {
  const fullName = [entry.firstName.trim(), entry.lastName.trim()].filter(Boolean).join(' ').trim()
  const cityRow = [entry.postalCode.trim(), entry.city.trim()].filter(Boolean).join(' ').trim()
  const province = entry.province.trim()
  const country = countryLabel.trim()
  const locationRow = [cityRow, province ? `(${province})` : '', country].filter(Boolean).join(' ').trim()
  const phone = entry.phone.trim()

  return [fullName, entry.addressLine.trim(), locationRow, phone].filter(Boolean).join('\n')
}
